<fieldset class="field-set dx-theme-border-color">
    <legend class="legend-title">AP Invoice Header Detail</legend>
    <div class="fieldset-container">
        <dx-form
            *ngIf="!!workflowEditor"
            width="100%"
            height="100%"
            labelLocation="top"
            [showColonAfterLabel]="true"
            [colCount]="1"
        >
            <dxi-item itemType="group" [colCount]="6">
                <dxi-item>
                    <dxo-label text="Invoice #"></dxo-label>
                    <div *dxTemplate>
                        <app-hyperlink-creator
                            [displayText]="workflowEditor?.invoiceNumber"
                            (onLinkClick)="onInvoiceClick()"
                        ></app-hyperlink-creator>
                    </div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Invoice Date"></dxo-label>
                    <div *dxTemplate>{{ getFormattedDate(workflowEditor?.invoiceDate) }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Amount To Pay"></dxo-label>
                    <div *dxTemplate>{{ getFormattedCurrency(workflowEditor?.amount) | ccCurrency }}</div>
                </dxi-item>
                <dxi-item>
                    <dxo-label text="Account #"></dxo-label>
                    <div *dxTemplate>
                        <app-hyperlink-creator
                            [displayText]="vendorAccountNumber"
                            (onLinkClick)="onVendorAccountClick()"
                        ></app-hyperlink-creator>
                    </div>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="2" [colSpan]="2">
                    <dxi-item [visible]="boardApprovalEnabled" [isRequired]="boardApprovalEnabled">
                        <dxo-label text="Board Approval Required"></dxo-label>
                        <div *dxTemplate>
                            <dx-switch
                                switchedOnText="Yes"
                                switchedOffText="No"
                                [disabled]="workflowEditor?.boardApprovalRequired"
                                [elementAttr]="{ class: 'field-switch' }"
                                [(value)]="boardApprovalRequired"
                            ></dx-switch>
                        </div>
                    </dxi-item>
                    <dxi-item itemType="empty" [visible]="!boardApprovalEnabled"></dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <div *ngIf="payeeType === 'VENDOR'" class="button-item">
                                <dx-button
                                    type="default"
                                    text="Coding Default"
                                    (onClick)="onCodingDefaultClick()"
                                ></dx-button>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" [colCount]="8">
                <dxi-item [colSpan]="2">
                    <dxo-label text="Due Date"></dxo-label>
                    <div *dxTemplate>
                        <dx-date-box
                            type="date"
                            [readOnly]="!allowEditInvoiceHeaderDetails"
                            [min]="closedBookPeriod"
                            [openOnFieldClick]="true"
                            [showClearButton]="true"
                            [(value)]="workflowEditor.dueDate"
                        ></dx-date-box>
                    </div>
                </dxi-item>
                <dxi-item [colSpan]="2" [isRequired]="true">
                    <dxo-label text="GL Post"></dxo-label>
                    <div *dxTemplate>
                        <dx-date-box
                            type="date"
                            [readOnly]="!allowEditInvoiceHeaderDetails"
                            [min]="closedBookPeriod"
                            [openOnFieldClick]="true"
                            [showClearButton]="true"
                            [(value)]="workflowEditor.postDate"
                        ></dx-date-box>
                    </div>
                </dxi-item>
                <dxi-item [colSpan]="2" [isRequired]="true">
                    <dxo-label text="Handling"></dxo-label>
                    <div *dxTemplate>
                        <div class="row-container">
                            <div class="add-padding-right full-width">
                                <dx-select-box
                                    displayExpr="displayText"
                                    valueExpr="specialHandlingId"
                                    [readOnly]="!allowEditInvoiceHeaderDetails"
                                    [searchEnabled]="true"
                                    [dataSource]="specialHandlingSource"
                                    [(value)]="workflowEditor.specialHandlingId"
                                ></dx-select-box>
                            </div>
                            <div *ngIf="workflowEditor.specialHandlingId === 2" class="add-padding-right">
                                <div *ngIf="!!workflowEditor?.specialInstruction" class="icon-content">
                                    <i
                                        title="Special Instructions"
                                        class="fa-2x cc-icon-check"
                                        [ngClass]="iconNotes"
                                        (click)="onSpecialInstructionClick()"
                                    ></i>
                                </div>
                                <div *ngIf="!workflowEditor?.specialInstruction" class="icon-content">
                                    <i
                                        title="Special Instructions"
                                        class="fa-2x dx-theme-accent-as-text-color"
                                        [ngClass]="iconEmptyNotes"
                                        (click)="onSpecialInstructionClick()"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </dxi-item>
                <dxi-item itemType="group" [colCount]="3" [colSpan]="2">
                    <dxi-item>
                        <dxo-label text="EFT Account"></dxo-label>
                        <div *dxTemplate>
                            <dx-switch
                                switchedOnText="Yes"
                                switchedOffText="No"
                                [readOnly]="!allowEditInvoiceHeaderDetails"
                                [disabled]="!isEFTEnabled"
                                [elementAttr]="{ class: 'field-switch' }"
                                [(value)]="workflowEditor.isEFTAccount"
                                (onValueChanged)="onEFTValueChanges($event)"
                            ></dx-switch>
                        </div>
                    </dxi-item>
                    <dxi-item [colSpan]="2">
                        <dxo-label text="Late Fee Included"></dxo-label>
                        <div *dxTemplate>
                            <div class="row-container">
                                <div class="add-padding-right">
                                    <dx-switch
                                        switchedOnText="Yes"
                                        switchedOffText="No"
                                        [readOnly]="!allowEditInvoiceHeaderDetails"
                                        [elementAttr]="{ class: 'field-switch' }"
                                        [(value)]="isLateFeeIncluded"
                                    ></dx-switch>
                                </div>

                                <dx-number-box
                                    [readOnly]="!allowEditInvoiceHeaderDetails"
                                    [disabled]="!isLateFeeIncluded"
                                    [showClearButton]="true"
                                    [showSpinButtons]="false"
                                    [format]="currencyFormat"
                                    [(value)]="workflowEditor.lateFee"
                                ></dx-number-box>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" [colCount]="6">
                <dxi-item [colSpan]="3">
                    <dxo-label text="Description"></dxo-label>
                    <div *dxTemplate>
                        <div class="row-container">
                            <div class="add-padding-right full-width">
                                <dx-text-box
                                    [readOnly]="!allowEditInvoiceHeaderDetails"
                                    [(value)]="workflowEditor.description"
                                ></dx-text-box>
                            </div>
                            <dx-button
                                type="default"
                                text="Update Description"
                                [disabled]="!allowEditInvoiceHeaderDetails"
                                [icon]="iconEdit"
                                (onClick)="onUpdateDescriptionClick()"
                            ></dx-button>
                        </div>
                    </div>
                </dxi-item>

                <dxi-item [colSpan]="2">
                    <dxo-label text="Bank Account"></dxo-label>
                    <div *dxTemplate>
                        <app-multi-column-selector
                            #bankAccountSelector
                            [name]="'Bank Account'"
                            [readOnly]="!allowEditInvoiceHeaderDetails"
                            [gridSource]="bankAccountSource"
                            [boxValue]="bankAccountBoxValue"
                            [valueExpr]="'bankAccountId'"
                            [displayExpr]="'displayBankName'"
                            [columnDef]="bankAccountColumns"
                            [dropDownButtonTemplate]="'dropDownButton'"
                            [dropDownOptions]="{ width: 'auto' }"
                            [showClearButton]="false"
                            [placeholder]="'Select Bank Account...'"
                            (gridSelectionEvent)="onBankAccountSelection($event)"
                        ></app-multi-column-selector>
                    </div>
                </dxi-item>
                <dxi-item itemType="empty" [visible]="!workflowEditor?.bankAccountId"></dxi-item>
                <dxi-item [visible]="!!workflowEditor?.bankAccountId">
                    <dxo-label text="Bank Balance"></dxo-label>
                    <div *dxTemplate>
                        <div class="cc-text-bold">{{ getFormattedCurrency(bankBalance) | ccCurrency }}</div>
                    </div>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</fieldset>

<app-workflow-iva-history
    *ngIf="showInvoiceHistory"
    [communityId]="workflowEditor?.communityId"
    [payee]="payee"
    [mode]="ivaHistoryMode"
    [title]="ivaHistoryTitle"
    [workflowId]="workflowEditor?.workflowId"
    [vendorAccountNumber]="vendorAccountNumber"
    [invoiceHistoryBaseParams]="invoiceHistoryBaseParams"
    [vendorAccountHistoryBaseParams]="vendorAccountHistoryParams"
    (closeIVAHistory)="onCloseHistory()"
></app-workflow-iva-history>

<!-- Special Handling Instruction -->
<dx-popup
    minWidth="150px"
    minHeight="150px"
    width="30%"
    height="25%"
    title="Special Instructions"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="false"
    [closeOnOutsideClick]="false"
    [(visible)]="showSpecialInstructions"
    (onHidden)="onSpecialInstructionsPopUpClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-text-area
                        class="textarea-input"
                        maxHeight="150"
                        [(value)]="workflowEditor.specialInstruction"
                    ></dx-text-area>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container">
                        <div class="right-container">
                            <dx-button
                                type="success"
                                text="OK"
                                [icon]="iconSave"
                                (onClick)="onSpecialInstructionsPopUpClose()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<!-- Coding Default Editor -->
<app-workflow-coding-default
    *ngIf="showCodingDefaultEditor"
    [communityId]="workflowEditor?.communityId"
    [workflowId]="workflowEditor?.workflowId"
    [managementCompanyId]="managementCompanyId"
    [payee]="payee"
    [payeeCode]="workflowEditor?.payeeCode"
    [vendorAccountId]="workflowEditor?.vendorAccountId"
    [vendorAccountNumber]="vendorAccountNumber"
    [workflowStep]="workflowStep"
    (onClose)="onCodingDefaultEditorClose()"
></app-workflow-coding-default>
